<template>
  <MainWrapperMobile>
    <template #default="{ drawerOpen, updateDrawerOpen }">
      <MainMobileMenu
        :open="drawerOpen"
        @update:open="updateDrawerOpen"
      >
        <DSSidebarItem
          label="All clients"
          :icon="UsersIcon"
          class="w-full h-10 justify-start"
          @click="clientsOpen = true"
        />
      </MainMobileMenu>
      <MobileSheet
        v-model:open="clientsOpen"
        title="All clients"
      >
        <AdvisorClientsTree />
      </MobileSheet>
    </template>
    <template #header>
      <div class="flex-1 min-w-0 h-11 flex items-center gap-2 px-2">
        <span class="flex items-center justify-center size-7 rounded-ds-sm bg-accent text-brand shrink-0">
          <LandmarkIcon
            class="size-3.5"
            aria-hidden="true"
          />
        </span>
        <span class="text-[15px] font-bold text-foreground whitespace-nowrap">Advisor mode</span>
      </div>
    </template>
    <template #content>
      <div class="flex-auto min-h-0 -my-3 -mx-4 p-4 bg-background overflow-y-auto">
        <router-view v-slot="{ Component }">
          <component :is="Component" />
        </router-view>
      </div>
    </template>
  </MainWrapperMobile>
</template>

<script setup lang="ts">
import { ref } from 'vue'

import AdvisorClientsTree from './components/AdvisorClientsTree.vue'
import MainMobileMenu from '../components/MainMobileMenu.vue'
import MainWrapperMobile from '../components/MainWrapperMobile.vue'
import { DSSidebarItem } from '@ds'
import { LandmarkIcon, UsersIcon } from '@lucide/vue'
import MobileSheet from '../components/MobileSheet.vue'

const clientsOpen = ref(false)
</script>
